import { Link } from "react-router-dom";
import { Instagram, Phone, MapPin, MessageCircle } from "lucide-react";
import { SERVICES, CONTACT } from "@/data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-[#08090B] pt-20">
    <div className="mx-auto grid max-w-[1440px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-5">
        <img src="/img/logo.jpg" alt="DOG'Z Training & Hotel" className="h-36 w-36 object-cover" />
        <p className="mt-6 max-w-sm text-white/70">
          Treino, hotel, creche, criação de Pastor Alemão e estética canina em Palmeira, Braga.
        </p>
      </div>
      <div className="lg:col-span-3">
        <p className="mb-5 font-mono text-xs uppercase tracking-[0.25em] text-[#C8D484]">Serviços</p>
        <ul className="space-y-3">
          {SERVICES.map((s) => (
            <li key={s.slug}>
              <Link to={`/servicos/${s.slug}`} data-testid={`footer-link-${s.slug}`} className="text-white/80 transition-colors hover:text-[#C8D484]">
                {s.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="space-y-4 lg:col-span-4">
        <p className="mb-5 font-mono text-xs uppercase tracking-[0.25em] text-[#C8D484]">Contactos</p>
        <a href={CONTACT.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 text-white/90 hover:text-[#C8D484]">
          <Phone className="h-4 w-4" /> {CONTACT.phone}
        </a>
        <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-3 text-white/90 hover:text-[#C8D484]">
          <MessageCircle className="h-4 w-4" /> WhatsApp
        </a>
        <a href={CONTACT.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="flex items-center gap-3 text-white/90 hover:text-[#C8D484]">
          <Instagram className="h-4 w-4" /> {CONTACT.instagramHandle}
        </a>
        <a href={CONTACT.instagramBanhos} target="_blank" rel="noreferrer" data-testid="footer-instagram-banhos" className="flex items-center gap-3 text-white/90 hover:text-[#C8D484]">
          <Instagram className="h-4 w-4" /> {CONTACT.instagramBanhosHandle} <span className="text-sm text-white/60">(Banhos & Tosquias)</span>
        </a>
        <a href={CONTACT.mapLink} target="_blank" rel="noreferrer" data-testid="footer-address" className="flex items-center gap-3 text-white/90 hover:text-[#C8D484]">
          <MapPin className="h-4 w-4" /> {CONTACT.address}
        </a>
      </div>
    </div>
    <p aria-hidden className="pointer-events-none mt-16 select-none whitespace-nowrap text-center font-display text-[24vw] font-semibold uppercase leading-[0.75] tracking-tighter text-white/[0.06]">
      Dog'z
    </p>
    <div className="mx-auto flex max-w-[1440px] flex-col gap-2 border-t border-white/10 px-5 py-6 text-xs text-white/60 sm:flex-row sm:justify-between sm:px-8 lg:px-12">
      <span>© {new Date().getFullYear()} DOG'Z Training & Hotel. Todos os direitos reservados.</span>

    </div>
  </footer>
);
